import { render } from "./NewLink.vue?vue&type=template&id=606b1cc6&scoped=true"
import script from "./NewLink.vue?vue&type=script&lang=js"
export * from "./NewLink.vue?vue&type=script&lang=js"

import "./NewLink.vue?vue&type=style&index=0&id=606b1cc6&lang=scss&scoped=true"
import "./NewLink.vue?vue&type=style&index=1&id=606b1cc6&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-606b1cc6"]])

export default __exports__